import { render } from "./TripCompanion.vue?vue&type=template&id=3b01d472&scoped=true"
import script from "./TripCompanion.vue?vue&type=script&lang=js"
export * from "./TripCompanion.vue?vue&type=script&lang=js"

import "./TripCompanion.vue?vue&type=style&index=0&id=3b01d472&scoped=true&lang=css"

import exportComponent from "/Users/robertprikryl/smartAIm/unity_media/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b01d472"]])

export default __exports__